var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGaiaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.531,
    height: 41.249,
    viewBox: "0 0 97.531 41.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-1222.3 -442.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1270.692,571.895l-48.392,1.232,48.392,1.232,49.139-1.232Z",
    transform: "translate(0 -102.082)",
    fill: "#89cff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1234.642 476.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1282.391,608.306v2.372q0,.4.455.4h1.394a1.722,1.722,0,0,0,1.752-1.3v1.82h-5.315q.716-.339.717-.871V605.6q0-.532-.717-.871h5.005v1.82a1.746,1.746,0,0,0-1.791-1.3h-1.5v2.536h1.578a1.125,1.125,0,0,0,.92-.523v1.52a1.157,1.157,0,0,0-.92-.474Z",
    transform: "translate(-1280.677 -604.656)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1319.464,611.6h-.62l-2.207-5.789a2.465,2.465,0,0,0-.8-1.084h2.469a.911.911,0,0,0-.5.736.612.612,0,0,0,.039.213l1.5,4.773,1.53-4.831a.478.478,0,0,0,.01-.1v-.058a.928.928,0,0,0-.513-.736h1.675a3.686,3.686,0,0,0-.61,1.084Z",
    transform: "translate(-1308.401 -604.656)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1356.507,608.306v2.372q0,.4.455.4h1.394a1.722,1.722,0,0,0,1.752-1.3v1.82h-5.315q.716-.339.717-.871V605.6q0-.532-.717-.871h5.005v1.82a1.747,1.747,0,0,0-1.791-1.3h-1.5v2.536h1.578a1.126,1.126,0,0,0,.92-.523v1.52a1.157,1.157,0,0,0-.92-.474Z",
    transform: "translate(-1339.124 -604.656)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1396.3,609.729a2.446,2.446,0,0,0,1.317,1.869H1396.5q-1.065-.01-1.4-1.743-.242-1.142-1.026-1.336h-.581v1.733a1.329,1.329,0,0,0,.745,1.346h-2.449q.707-.329.707-.871V605.6q0-.542-.707-.871h1.946q2.875,0,2.962,1.733,0,1.685-2.023,1.946A1.86,1.86,0,0,1,1396.3,609.729Zm-2.817-4.569v2.411q0,.533.726.533,1.432-.155,1.432-1.472,0-1.442-1.665-1.471Z",
    transform: "translate(-1368.293 -604.656)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1431.122,606.781l-1.1,4.744h-.775l-1.859-6.079a4.005,4.005,0,0,0-.446-.794h2.256q-.629.445-.629.852l1.288,4.376,1.2-5.247h.349l1.607,5.441,1.181-4.6q0-.416-.707-.823h1.8a3.972,3.972,0,0,0-.416.794l-1.665,6.079h-.765Z",
    transform: "translate(-1396.018 -604.584)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1483.034,607.946a3.808,3.808,0,0,1-.784,2.507,2.781,2.781,0,0,1-2.313.958,2.921,2.921,0,0,1-2.4-.958,3.811,3.811,0,0,1-.784-2.507,4.017,4.017,0,0,1,.775-2.585,2.814,2.814,0,0,1,2.313-.958,2.945,2.945,0,0,1,2.42.958A4.019,4.019,0,0,1,1483.034,607.946Zm-3.1,3.04a1.6,1.6,0,0,0,1.433-.794,4.163,4.163,0,0,0,.513-2.246,4.111,4.111,0,0,0-.581-2.246,1.707,1.707,0,0,0-1.462-.813,1.593,1.593,0,0,0-1.423.794,4.205,4.205,0,0,0-.513,2.265,3.966,3.966,0,0,0,.591,2.217A1.686,1.686,0,0,0,1479.936,610.986Z",
    transform: "translate(-1435.298 -604.403)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1523.435,609.729a2.446,2.446,0,0,0,1.317,1.869h-1.123q-1.065-.01-1.4-1.743-.242-1.142-1.026-1.336h-.581v1.733a1.33,1.33,0,0,0,.745,1.346h-2.449q.707-.329.707-.871V605.6q0-.542-.707-.871h1.946q2.875,0,2.962,1.733,0,1.685-2.023,1.946A1.86,1.86,0,0,1,1523.435,609.729Zm-2.817-4.569v2.411q0,.533.726.533,1.433-.155,1.433-1.472,0-1.442-1.665-1.471Z",
    transform: "translate(-1468.547 -604.656)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1559.859,611.075a1.723,1.723,0,0,0,1.762-1.259V611.6H1557q.706-.329.707-.871V605.6q0-.542-.707-.871h2.459q-.755.329-.755.871v5.1q0,.378.581.378Z",
    transform: "translate(-1498.583 -604.656)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1593.262,604.724a3.412,3.412,0,0,1,2.488.939,3.571,3.571,0,0,1,.842,2.536,3.442,3.442,0,0,1-.842,2.449,3.36,3.36,0,0,1-2.488.949H1590.7q.707-.329.707-.871V605.6q0-.542-.707-.871Zm-.048,6.409a2.014,2.014,0,0,0,1.675-.831,3.345,3.345,0,0,0,.629-2.078,3.721,3.721,0,0,0-.629-2.2,1.937,1.937,0,0,0-1.675-.87h-.813v5.538q0,.445.649.445Z",
    transform: "translate(-1525.153 -604.656)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1381.794,454.97q-3.717-9.648-4.485-11.295c-.167-.345-.351-.517-.549-.517q-.409,0-1.231.055c-.551.037-.965.054-1.249.054s-.734-.026-1.325-.078-1.026-.078-1.309-.078c-.167,0-.314.2-.439.6q-.328,1.037-4.173,11.435-3.545,9.617-3.544,10.025,0,.454,2.4.455a26.309,26.309,0,0,0,3.576-.127q.425-.109.722-1.412a1.439,1.439,0,0,1,1.882-1.8c-.087-.059-.172-.122-.252-.188a2.767,2.767,0,0,1-1.077-2.073v-1h7.188l0,1a2.838,2.838,0,0,1-1.339,2.27,6.821,6.821,0,0,1,1.24.085,6.015,6.015,0,0,1,.832,2.415.843.843,0,0,0,.674.705,19.813,19.813,0,0,0,2.886.127,17.965,17.965,0,0,0,2.917-.127c.262-.073.392-.2.392-.393Q1385.527,464.681,1381.794,454.97Zm-6.175,3.235-.007-.013-.583-1.184-.724-1.473-.714,1.452h0l-.592,1.205-.007.014a2.526,2.526,0,0,1-1.442-2.586c0-2.056,2.756-5.828,2.756-5.828s2.758,3.772,2.758,5.828A2.527,2.527,0,0,1,1375.619,458.2Z",
    transform: "translate(-111.34 -0.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1249.778,464.469q.031.424-.439.423a11.635,11.635,0,0,1-1.718-.345q-1.42-.345-1.749-.471a17.2,17.2,0,0,1-6.29,1.286,10.548,10.548,0,0,1-7.953-3.231,11.116,11.116,0,0,1-3.074-8.047,11.8,11.8,0,0,1,2.98-8.251,10.281,10.281,0,0,1,7.984-3.388,11.178,11.178,0,0,1,4.486.91,8.507,8.507,0,0,1,3.577,2.824,1.2,1.2,0,0,1,.267.533,5.945,5.945,0,0,1-1.4,2.251q-1.4,1.749-1.812,1.749a3.059,3.059,0,0,1-.722-.643,6.635,6.635,0,0,0-1.569-1.192,5.462,5.462,0,0,0-2.635-.643,4.5,4.5,0,0,0-3.733,1.757,6.268,6.268,0,0,0-1.286,4.031,5.848,5.848,0,0,0,1.333,4.047,4.977,4.977,0,0,0,3.906,1.537,9.654,9.654,0,0,0,3.577-.8q-.047-.518-.283-2.635a22.252,22.252,0,0,1-.2-2.635q0-.3.2-.361a.735.735,0,0,1,.251-.031q.455,0,1.372.086t1.388.086q.5,0,1.506-.071t1.506-.071q.392,0,.392.518,0,.753-.086,2.274t-.086,2.275q0,2.024.3,6.055Z",
    transform: "translate(-4.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1508.73,455.309q0,1.851.094,5.569t.094,5.568q0,.314-.141.392a3.293,3.293,0,0,1-.408.063,23.457,23.457,0,0,1-2.729.125,19.986,19.986,0,0,1-2.918-.125q-.455-.094-.455-.487,0,.251.141-2.761.283-6.353.283-8.345,0-1.679-.11-5.035t-.11-5.036q0-.345.361-.345.486,0,1.467.047t1.467.047q.486,0,1.435-.047t1.435-.047q.455,0,.455.345,0,1.679-.18,5.036T1508.73,455.309Z",
    transform: "translate(-220.778 -1.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1588.5,465.1q0,.283-.392.392a18.034,18.034,0,0,1-2.918.125,19.842,19.842,0,0,1-2.886-.125.846.846,0,0,1-.675-.706,6,6,0,0,0-.831-2.416,34.672,34.672,0,0,0-4.2-.11,12.394,12.394,0,0,0-2.839.141,4.313,4.313,0,0,0-.6,1.679q-.3,1.3-.721,1.412a26.411,26.411,0,0,1-3.576.125q-2.4,0-2.4-.455,0-.408,3.545-10.023,3.843-10.4,4.172-11.436.188-.6.439-.6.423,0,1.31.078t1.326.078q.423,0,1.247-.055t1.231-.055q.3,0,.549.518.768,1.647,4.486,11.294Q1588.5,464.681,1588.5,465.1Zm-11.122-14.29q-.329.69-1.114,3a16.262,16.262,0,0,0-.847,2.871q0,.282.941.314.486.031,1.6.031,1.035,0,1.145-.251a.613.613,0,0,0,.031-.22,15.287,15.287,0,0,0-.722-2.855A22.2,22.2,0,0,0,1577.377,450.814Z",
    transform: "translate(-271.398 -0.526)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaiaIcon);
export default __webpack_public_path__ + "static/media/gaiaIcon.d3628ada7ab1af6d9f5c235ff32ae37e.svg";
export { ForwardRef as ReactComponent };